import type { ReactNode } from "react";
import styles from "./AppShell.module.css";

type Props = {
  roster: ReactNode;
  chat: ReactNode;
  showChatOnMobile: boolean;
};

export function AppShell({ roster, chat, showChatOnMobile }: Props) {
  return (
    <div className={styles.appShell}>
      <aside
        className={`${styles.sidePanel} ${showChatOnMobile ? styles.sidePanelHidden : ""}`}
      >
        {roster}
      </aside>
      <main
        className={`${styles.chatPanel} ${!showChatOnMobile ? styles.chatPanelHidden : ""}`}
      >
        {chat}
      </main>
    </div>
  );
}

export function EmptyChatPlaceholder() {
  return (
    <div className={styles.emptyChat}>
      <strong>A.A.R.I.A.</strong>
      <span>Select an instance to start chatting</span>
    </div>
  );
}
